
import BetHistory from '@/components/dialogs/history-view.vue'
import SettingView from '@/components/dialogs/setting-dialog-view.vue'
import ChangePasswordView from '@/components/dialogs/change-pass-view.vue'
import ChangePassRequired from '@/components/dialogs/change-pass-required.vue'
import RedEnvelop from '@/components/dialogs/red-envelop.vue'
import RedEnvelop2 from '@/components/dialogs/red-envelop-2.vue'
import RuleView from '@/components/dialogs/rule-view.vue'
import HeaderView from '@/components/header/index.vue'
import BannerView from '@/components/loby/banner-view.vue'
import DListItemView from '@/components/loby/d-list-item-view.vue'
import DListItemMultiView from '@/components/loby/d-list-item-multi-view.vue'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { LobyMixin } from './mixin'

//

@Options({
    components: {
        HeaderView,
        BannerView,
        DListItemView,
        BetHistory,
        SettingView,
        ChangePasswordView,
        DListItemMultiView,
        ChangePassRequired,
        'red-envelop': RedEnvelop,
        'red-envelop-2': RedEnvelop2,
        'rule-view': RuleView
    }
})
export default class PcLoby extends Mixins(LobyMixin) {}
